module.exports = __webpack_public_path__ + "fonts/4a4ab78765427bec247c9d663b06b5bd.svg";